import { BodenvegetationZeile } from '../data-model';

/**
 * Normalisiert einen Artnamen fuer den Dubletten-Vergleich:
 * Whitespace an den Raendern weg, Vergleich case-insensitiv.
 */
function normArt(s?: string): string {
	return (s ?? '').trim().toLowerCase();
}

/**
 * Prueft, ob die Vegetationszeile am gegebenen Index eine Art enthaelt, die
 * in *derselben Schicht* bereits in einer anderen Zeile erfasst wurde.
 *
 * Scope ist bewusst pro Schicht: dieselbe Art darf in verschiedenen Schichten
 * (z.B. eine Baumart in B1 und als Jungwuchs in der Krautschicht) vorkommen,
 * aber nicht zweimal in derselben Schicht.
 *
 * Leere Artnamen werden nie als Dublette gemeldet (frische Zeilen ohne Eingabe).
 */
export function isVegetationDuplicate(
	vegetationen: BodenvegetationZeile[] | undefined,
	index: number
): boolean {
	if (!vegetationen) return false;
	const row = vegetationen[index];
	if (!row) return false;
	const art = normArt(row.vegetation);
	if (!art) return false;
	return vegetationen.some(
		(other, i) =>
			i !== index &&
			other.schicht === row.schicht &&
			normArt(other.vegetation) === art
	);
}
